import AuthLayout from "@container/layout/auth";
import NewCampaignContainer from "@container/agent-call-setup/new";

export default function AgentCallSetupNewPage() {
    return (
        <AuthLayout>
            <NewCampaignContainer />
        </AuthLayout>
    );
}
